module.exports = __webpack_public_path__ + "img/user-7.7211e848.png";